
import { defineComponent } from 'vue';
import api from '@/api/my/plugins';
import utils from '@/utils';
import { IExtension, IHost } from '@/types/models';
import agentPlugins from '@/api/agent/plugins';

interface IState {
  pageType: string;
  hosts: IHost[];
  host: IHost;
  extension: IExtension;
}

export default defineComponent({
  name: 'Domains',
  emits: ['close'],
  props: {
    userName: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pageType: 'hosts',
      hosts: [],
      host: {} as IHost,
      extension: {} as IExtension,
    } as IState;
  },
  methods: {
    apiGet() {
      this.pageType = 'hosts';
      this.hosts = [];
      this.host = {} as IHost;
      this.extension = {} as IExtension;

      api.getHosts({
        userName: this.userName,
        name: this.name,
      }, (res) => {
        if (!res) return;
        this.hosts = res.hosts;
        this.extension = res.extension;

        for (const host of this.hosts) {
          agentPlugins.getPlugins(
            host.hostName,
            host.nodeName,
            host.isHongKong,
            {
              securityKey: host.securityKey,
            },
            (res2) => {
              host.plugins = res2.plugins;
            },
          );
        }
      });
    },

    getUniqueName(host?: IHost) {
      return utils.getHostUniqueName(host || this.host);
    },

    getUrl(hostName: string, nodeName: string, isHongKong: boolean): string {
      return utils.getHostUrl(hostName, nodeName, isHongKong);
    },

    isInstall(host: IHost) {
      const plugin = host.plugins.find((x) => x.publisher === this.userName && x.name === this.name);
      if (!plugin) return true;
      return false;
    },

    isUpdate(host: IHost) {
      const plugin = host.plugins.find((x) => x.publisher === this.userName && x.name === this.name);
      if (!plugin) return false;
      if (plugin.version !== this.extension.latestVersion) return true;
      return false;
    },

    btnDeployClick(host: IHost, isUpdate: boolean) {
      this.host = host;
      const title = isUpdate ? '升级' : '部署';

      utils.alertDelete(
        {
          title: `${title}插件`,
          text: `此操作将插件 ${this.name} ${title}到网站云 ${utils.getHostUniqueName(this.host)}，确定吗？`,
          button: `确定${title}`,
        },
        () => {
          api.deploy(
            {
              userName: this.userName,
              name: this.name,
              hostId: host.id,
            },
            () => {
              this.pageType = 'success';
            },
          );
        },
      );
    },

    btnCloseClick() {
      this.$emit('close');
    },
  },
  watch: {
    userName: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.apiGet();
        }
      },
      deep: false,
    },
    name: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.apiGet();
        }
      },
      deep: false,
    },
  },
  mounted() {
    this.apiGet();
  },
});
